import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs';
import padStart from 'lodash/padStart';

const VideoConferenceTimer = ({ autoDisconnect, classNames = "", startTime, endTime }) => {
  const [countdown, setCountdown] = useState(null);
  
  const getCountdownStatus = (startTime, endTime) => {
    const now = dayjs();
    const timeUntilStart = dayjs.duration(startTime.diff(now));
    const timeUntilEnd = dayjs.duration(endTime.diff(now));

    if (now.isAfter(endTime)) {
      return {
        message: autoDisconnect ? "Expired" : "Over Running by " + (timeUntilEnd.asMinutes() <= -60 ? timeUntilEnd.humanize() : `${padStart(Math.abs(timeUntilEnd.minutes()), 2, "0")}:${padStart(Math.abs(timeUntilEnd.seconds()), 2, "0")}`),
        classes: "bg-red-500 animate-pulse",
      };
    }

    if (timeUntilEnd.asSeconds() <= 30 && autoDisconnect) {
      return {
        message: `Disconnecting in ${timeUntilEnd.seconds()} seconds`,
        classes: `${timeUntilEnd > 10 ? 'bg-orange-600' : 'bg-red-600'} animate-pulse`,
      }
    }

    if (now.isBetween(startTime, endTime)) {
      return {
        message: `Expires in ${timeUntilEnd.format("mm:ss")}`,
        classes: `${timeUntilEnd.asSeconds() <= 20 ? "bg-orange-600 animate-pulse " : "bg-green-600"}`,
      };
    }

    if (now.isBefore(startTime) && timeUntilStart.asSeconds() < 60) {
      return {
        message: `Starts in ${timeUntilStart.seconds()} seconds`,
        classes: `bg-orange-600 ${timeUntilStart.seconds() <= 10 ? "animate-pulse" : ""}`,
      };
    }

    if (now.isBefore(startTime) && timeUntilStart.asSeconds() < 300) {
      return {
        message: `Starts in ${timeUntilStart.format("mm:ss")}`,
        classes: "bg-orange-400",
      };
    }

    return {
      message: `Starts in ${timeUntilStart.humanize()}`,
      classes: "bg-blue-600",
    };
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(getCountdownStatus(startTime, endTime));
    }, 1000); // Runs every second

    return () => clearInterval(interval);
  }, [startTime, endTime]) // eslint-disable-line react-hooks/exhaustive-deps
  
  return (
    <>
      {countdown && (
        <div className={`${classNames} ${countdown.classes} min-w-36 text-center text-sm px-4 py-2 rounded-lg text-white`}>
          <span className='font-semibold'>{countdown.message}</span>
        </div>
      )}
    </>
  )
}

VideoConferenceTimer.propTypes = {
  autoDisconnect: PropTypes.bool.isRequired,
  classNames: PropTypes.string,
  startTime: PropTypes.object.isRequired,
  endTime: PropTypes.object.isRequired,
}

export default VideoConferenceTimer